/* Token check, merchant config, invoice, cancel and redirect.
 *
 * Extracted verbatim from src/App.script.js. Behaviour is unchanged;
 * these methods run on the App instance exactly as before.
 */
import axios from "axios";

export default {
  methods: {

    MerchantInfo(orderid) {
      // Check if merchantConfigData is already populated
      if (Object.keys(this.merchantConfigData).length > 0) {
        this.processMerchantInfo(this.merchantConfigData);
      } else {
        const options = {
          method: "GET",
          url: this.base_url + "merchant-config/" + orderid,
          headers: {
            Authorization: "Bearer " + this.sp_token,
            "Content-Type": "application/json",
          },
        };

        axios
          .request(options)
          .then((response) => {
            // Store the response data for future use
            this.merchantConfigData = response.data;
            this.processMerchantInfo(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    processMerchantInfo(data) {
      this.sp_amount = data.gateway_info.request_amount;
      this.sp_amount_display = parseFloat(
        data.gateway_info.request_amount
      ).toFixed(2);
      this.sp_currency = data.gateway_info.currency;
      this.store_id = data.gateway_info.store_id;
      if(data.merchant_info[0].is_footer_logo === 0){
         this.footer_div_show = false;
      }
      this.customer_trxn_mobile_number = data.gateway_info.customer_phone_no;
      
      this.is_card_on_file_active = data.merchant_info[0].is_card_on_file;
      this.is_add_commission = data.merchant_info[0].is_add_commission;
      this.is_emi_active = data.merchant_info[0].is_emi;
      
      this.isCard = data.merchant_info[0].is_cards;
      this.isMbanking = data.merchant_info[0].is_mbanking;
      this.isIBanking = data.merchant_info[0].is_ibanking;
      const storeName =
        data.merchant_info[0].store_name != null
          ? String(data.merchant_info[0].store_name).trim()
          : "";
      this.merchant_name =
        storeName !== "" ? storeName : data.merchant_info[0].merchant_name;

      if (this.store_id === "1") {
        this.isEducation = data.merchant_info[0].is_education;
      } else {
        const currentDate = new Date();
        if (currentDate.getMonth() === 1 && currentDate.getFullYear() === 2025) {
          this.isEducation = data.merchant_info[0].is_education;
        } else {
          this.isEducation = false;
        }
      }

      if (data.merchant_info[0].store_logo === null) {
        this.merchant_logo = require("../assets/test_merchant_logos/shurjopay_logo.png");
      } else {
        this.merchant_logo =
          this.merchant_logo_image_base_url + data.merchant_info[0].store_logo;
      }

      if (data.gateway_info.bank.length > 0) {
        this.cards_gateways = data.gateway_info.bank;
        console.log(data.gateway_info.bank);
      }

      if (data.gateway_info.mfs.length > 0) {
        this.mfs_gateways = data.gateway_info.mfs;
      }

      if (data.gateway_info.internet.length > 0) {
        this.ibanking_gateways = data.gateway_info.internet;
      }

      this.preloadGatewayImages([
        this.cards_gateways,
        this.mfs_gateways,
        this.ibanking_gateways,
      ]);

      this.setActiveTabs(data.merchant_info[0]);
    },

    preloadGatewayImages(gatewayLists) {
      if (!this.image_base_url) return;

      const seen = Object.create(null);
      gatewayLists.forEach((list) => {
        if (!Array.isArray(list)) return;
        list.forEach((gateway) => {
          [gateway.image, gateway.hover_image].forEach((path) => {
            if (!path || seen[path]) return;
            seen[path] = true;
            const img = new Image();
            img.src = this.image_base_url + path;
          });
        });
      });
    },

    setActiveTabs(merchantInfo) {
      if (merchantInfo.tab_priority == 1) {
        this.logout_tab_decision = "1";
        this.active_tabs(1);
      } else if (merchantInfo.tab_priority == 2) {
        this.logout_tab_decision = "2";
        this.active_tabs(2);
      } else if (merchantInfo.tab_priority == 3) {
        this.logout_tab_decision = "3";
        this.active_tabs(3);
      } else {
        this.logout_tab_decision = "4";

        if (merchantInfo.is_cards == 1) {
          this.active_tabs(1);
        }

        if (merchantInfo.is_cards == 0 && merchantInfo.is_mbanking == 2) {
          this.active_tabs(2);
        }

        if (
          merchantInfo.is_cards == 0 &&
          merchantInfo.is_mbanking == 0 &&
          merchantInfo.is_ibanking == 3
        ) {
          this.active_tabs(3);
        }
      }

      let counter = [1, 2, 3].filter(
        (i) =>
          merchantInfo.is_cards == i ||
          merchantInfo.is_mbanking == i ||
          merchantInfo.is_ibanking == i
      ).length;

      this.total_assigned_tabs = counter;
      this.dwidth = counter === 3 ? "width:25%" : counter === 2 ? "width:33.33%" : "width:50%";
    },

    //applied during mounted
    CheckBackBtnClick() {
      var order_id = this.$route.query.order_id;
      var sp_token = this.$route.query.token;

      const options = {
        method: "POST",
        url: this.base_url + "method-verification",
        headers: {
          Authorization: "Bearer" + sp_token,
        },
        data: {
          order_id,
        },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 1) {
            this.CancelPayment();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //no need token — public /api/cancel
    CancelURL() {
      var order_id = this.$route.query.order_id;
      const options = {
        method: "POST",
        url: this.base_url + "cancel",
        data: {
          order_id,
        },
      };
      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 1) {
            window.location.href = response.data.url;
          } else {
            this.snackbar = true;
            this.color = "error";
            this.timeout = 2000;
            this.popup_text = "Something Went Wrong...";
          }
        })
        .catch((error) => {
          this.snackbar = true;
          this.color = "error";
          this.timeout = 2000;
          this.popup_text = "Something Went Wrong...";
        });
    },

    makeTransactionEMI() {
      console.log("**** CLICK EMI API");
      console.log(this.sp_orderid);
      this.show_emi_button = false;
      this.show_cards("emi");
      this.disableCardTab = true;
      this.disableMbankingTab = true;
      this.disableIBankingTab = true;
      this.disableLoginTab = true;
      this.disableProfileTab = true;
    },
    makeTransactionNonEMI() {
      console.log("**** CLICK Non EMI");
      // Assuming you have the required data like transaction_id
      const transactionId = this.sp_orderid;

      // Data to be sent in the request body
      const requestData = {
        transaction_id: transactionId,
      };

      // Make a POST request using axios
      axios
        .post(this.base_url + "emi/revert", requestData)
        .then((response) => {
          // Check if the response status is 200
          if (response.status === 200) {
            // If successful (status code 200), handle accordingly
            //this.handleSuccess(response.data);
            this.show_emi_button = true;
            this.disableCardTab = false;
            this.disableMbankingTab = false;
            this.disableIBankingTab = false;
            this.disableLoginTab = false;
            this.disableProfileTab = false;

            // this.show_cards('0');
            // this.showPaymentMethod('dbbl-two-nexus');
            // this.showPaymentMethod('dbbl-debit-visa');
            // this.showPaymentMethod('dbbl-debit-master');
            // this.showPaymentMethod('nexus-pay');
            // this.showPaymentMethod('tbl-visa');
          } else {
            // If not successful, handle accordingly
            this.handleFailure(response.status);
          }
        })
        .catch((error) => {
          // Handle errors
          console.error("Error:", error);
          // Do something else on error
        });
    },

    //token implemented
    CanceledPaymentAPI() {
      var order_id = this.$route.query.order_id;
      var sp_token = this.$route.query.token;
      const options = {
        method: "POST",
        url: this.base_url + "canceled",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: {
          order_id,
        },
      };

      axios
        .request(options)
        .then((response) => {
          if (response.data.message == 1) {
            window.location.href = response.data.url;
          } else {
            this.snackbar = true;
            this.color = "error";
            this.timeout = 2000;
            this.popup_text = "Something Went Wrong...";
          }
        })
        .catch((error) => {
          this.snackbar = true;
          this.color = "error";
          this.timeout = 2000;
          this.popup_text = "Something Went Wrong...";
        });
    },

    CancelPayment() {
      this.sp_orderid = this.$route.query.order_id;
      this.sp_token = this.$route.query.token;

      if (typeof this.sp_token === "undefined") {
        this.isMainDiv = false;
        this.isUnauthorized = true;
        this.isMaintenanceMode = false;
      } else {
        const options = {
          method: "POST",
          url: this.base_url + "check-token",
          headers: {
            Authorization: "Bearer " + this.sp_token,
          },
        };
        axios
          .request(options)
          .then((response) => {
            if (response.data.sp_code == "200") {
              this.CanceledPaymentAPI();
            } else if (response.data.sp_code == "1064") {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.isMainDiv = false;
              this.isUnauthorized = true;
              this.isMaintenanceMode = false;
              setTimeout(this.CancelURL, 500);
            }
          });
      }
    },

    generate_invoice() {
      var date = new Date();
      var ms_part = date.getMilliseconds();

      var orderID = this.$route.query.order_id;
      var order_id_part = orderID.substring(0, 3);

      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = " ";
      const charactersLength = characters.length;
      for (let i = 0; i < 6; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      let random_string = result.trim();
      this.invoiceno = order_id_part + random_string + ms_part;
    },

    //checked during render
    check_order() {
      var orderid = this.$route.query.order_id;
      var sp_token = this.$route.query.token;
      const options = {
        method: "POST",
        url: this.base_url + "chk-order",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: {
          orderid,
        },
      };

      axios
        .request(options)
        .then((response) => {
          this.merchant_info(response.data[0].store_id);
          this.sp_amount = response.data[0].payable_amount;

          this.sp_amount_display = parseFloat(
            response.data[0].payable_amount
          ).toFixed(2);

          this.sp_currency = response.data[0].currency;
          this.store_id = response.data[0].store_id;
          this.sp_return_url = response.data[0].return_url;
          this.sp_cancel_url = response.data[0].cancel_url;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //checked during render within check_order method
    merchant_info(store_idd) {
      var store_id = store_idd;
      var sp_token = this.$route.query.token;
      const options = {
        method: "POST",
        url: this.base_url + "get-merchant-info",
        headers: {
          Authorization: "Bearer " + sp_token,
        },
        data: {
          store_id,
        },
      };
      axios
        .request(options)
        .then((response) => {
          this.is_card_on_file_active = response.data[0].is_card_on_file;
          this.is_add_commission = response.data[0].is_add_commission;
          this.is_emi_active = response.data[0].is_emi;
          var CardVisibility = response.data[0].is_cards;
          var MbankingVisibility = response.data[0].is_mbanking;
          var IBnakingVisibility = response.data[0].is_ibanking;
          this.isCard = CardVisibility;
          this.isMbanking = MbankingVisibility;
          this.isIBanking = IBnakingVisibility;
          this.merchant_name = response.data[0].merchant_name;
          /**
           * If no merchant logo is set for merchnat than shows this
           */
          if (response.data[0].store_logo === null) {
            this.merchant_logo = require("../assets/test_merchant_logos/shurjopay_logo.png");
          }

          /**
           * If merchnat logo is set for merchnat than shows this
           */
          if (response.data[0].store_logo !== null) {
            this.merchant_logo =
              this.merchant_logo_image_base_url + response.data[0].store_logo;
          }

          /*Active Tabs Logic*/
          var tabs_val = [
            CardVisibility,
            MbankingVisibility,
            IBnakingVisibility,
          ];
          var f_tabs = [];
          var j = 0;
          for (let i = 0; i < tabs_val.length; i++) {
            const element = tabs_val[i];
            if (element !== 0) {
              f_tabs[j] = tabs_val[i];
              j++;
            }
          }
          //console.log("Active Tabs"+f_tabs[0]);
          this.active_tabs(f_tabs[0]);

          var counter = 0;
          for (let i = 1; i <= 3; i++) {
            if (
              CardVisibility == i ||
              MbankingVisibility == i ||
              IBnakingVisibility == i
            ) {
              counter++;
            }
          }
          if (counter == 3) {
            this.dwidth = "width:25%";
          }

          if (counter == 2) {
            this.dwidth = "width:33.33%";
          }

          if (counter == 1) {
            this.dwidth = "width:50%";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    merchant_gateway(gateway_type_id) {
      if (gateway_type_id == 1) {
        this.cards_gateways;
      }

      if (gateway_type_id == 2) {
        this.mfs_gateways;
      }

      if (gateway_type_id == 3) {
        this.ibanking_gateways;
      }
    },
  },
};
